import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const CommercialTransactionInfoPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">特定商取引に関する記載</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">特定商取引に関する表記</div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">事業者</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">IVA株式会社</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">代表者</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">相原嘉夫</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">メールアドレス</div>
              <div className="w-full justify-center text-black text-base font-normal underline leading-7">info【at】dondoncard.com</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">所在地</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">〒150-0011 東京都渋谷区東2-22-5 3F</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">販売価格帯</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">商品：各商品に記載された価格<br/>サービス：各商品に表記された価格に準じます。</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">商品等の引渡し時期</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">商品：注文確定後12日以内に商品を発送いたします。<br/>サービス：お客さまのサービス利用時</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">代金の支払い方法</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">クレジットカード決済</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">代金の支払い時期</div>
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">【クレジットカード決済】</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">購入手続完了時にお支払いが確定します。<br/>引き落とし日は、ご利用のクレジットカードの締め日や契約内容により異なります。<br/>ご利用のカード会社までお問い合わせください。</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">商品代金以外に必要な費用</div>
              <div className="flex flex-col justify-start items-start">
                <div className="w-full justify-center text-black text-base font-normal leading-7">取引が成立した際に手数料が発生します。詳細につきましては以下のページをご覧ください。</div>
                <Link to={`/terms/fees_charges${location.search}`} className="w-full justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">利用料・配送料について</Link>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">商品の返品・交換について</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                お客さま都合による返品・交換は受け付けておりません。<br/>
                不良品・誤配送など当社不備による返金については、<Link to={`/terms/compensation${location.search}`} className="text-black underline hover:text-[#0099d6]">補償</Link>に沿い、当社が適切と認める措置をとるものとします。<br/>
                出品者側の不備による商品の返送料は、出品者に送料をご負担いただきます。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">古物営業法に基づく表記</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">東京都公安委員会<br/>第303312318030号</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">電話番号</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">050-1722-8182</div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default CommercialTransactionInfoPage;